import { useRef } from "react";
import { motion, useInView, useMotionValue, useSpring } from "framer-motion";
import { useEffect } from "react";

const stats = [
  { value: 40, suffix: "+", label: "Brands launched & scaled" },
  { value: 25, prefix: "₹", suffix: "Cr+", label: "Marketplace GMV influenced" },
  { value: 5, suffix: "", label: "Marketplaces covered end-to-end" },
  { value: 14, prefix: "", suffix: " days", label: "Average time to go live" },
];

const Counter = ({ value, prefix = "", suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const mv = useMotionValue(0);
  const spring = useSpring(mv, { duration: 1800, bounce: 0 });

  useEffect(() => {
    if (inView) mv.set(value);
  }, [inView, value, mv]);

  useEffect(() => {
    const unsub = spring.on("change", (v) => {
      if (ref.current)
        ref.current.textContent = `${prefix}${Math.round(v)}${suffix}`;
    });
    return unsub;
  }, [spring, prefix, suffix]);

  return <span ref={ref}>{`${prefix}0${suffix}`}</span>;
};

export const Stats = () => {
  return (
    <section
      id="results"
      data-testid="stats-section"
      className="relative py-24 lg:py-32 bg-midnight"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-xs font-bold uppercase tracking-[0.25em] text-coal/40"
        >
          03 — Results
        </motion.span>
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-coal/10 border border-coal/10">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="bg-midnight p-8 lg:p-12"
            >
              <div className="font-display font-900 tracking-tighter text-5xl sm:text-6xl lg:text-7xl text-coal">
                <Counter value={s.value} prefix={s.prefix} suffix={s.suffix} />
              </div>
              <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-coal/45">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
